import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service'; 
import { Entry } from 'contentful';

@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.css'],
  standalone: false
})
export class CompanyInfoComponent implements OnInit {

  company: Entry<any>[] = [];

  constructor(
    private readonly contentfulService: ContentfulService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.contentfulService.getCompany()
    .then(company => {
      this.company = company;
      this.cdr.detectChanges();
    })
  }

}
